import { Box, styled, Typography } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  alignItems: 'center',
}));


const StyledLinkSpan = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '0.95rem',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}));

const HeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}));

const Field = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '30%',
});

const Label = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '0.95rem',
});

const LabelRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

const Value = styled(Typography)({
  fontSize: '0.95rem',
});

const MutedValue = styled(Value)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

const StatusBadge = styled(Box)({
  backgroundColor: '#d4f4dd',
  color: '#3b8c4a',
  fontWeight: 600,
  fontSize: '0.75rem',
  borderRadius: 8,
  padding: '2px 10px',
  display: 'inline-block',
  marginTop: 4,
  width: 'fit-content',
});

const UserSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  marginTop: '0.5rem',
});

const FinancialFieldsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
}));

const PersonnelRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));

const FinancialField = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
});

const ToggleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

export { Container, Row, HeaderRow, Field, Label, Value, MutedValue, StatusBadge, UserSection, StyledLinkSpan, LabelRow, FinancialFieldsGrid, FinancialField, PersonnelRow, ToggleContainer };
